/* eslint-disable */
import { useMemo } from 'react';
import { connect } from 'react-redux';
import { Button } from '@/Components/ui/button';
import GlobalSearch from '@/Components/globalSearch/search';
import { Filter, Plus } from 'lucide-react';
import drawerActions from '@/Actions/drawer.actions';

function ProductPlanHeader(props) {
	const {
		openLongTermModal = () => { },
		toggleFiltersDrawer,
		handleSearch = () => { },
		level = null,
		openInitiateModal = () => { },
		isShowMultiple = false,
		openCreateOrdersModal = () => { },
	} = props;

	const isBakingo = window.location.hostname?.includes('bakingo');

	const createButtons = [
		{
			id: 'reviewOrders',
			label: 'Review Orders & Plan Production',
			hint: 'Review buyer & kitchen orders, then plan',
			onClick: openCreateOrdersModal,
			show: !isShowMultiple,
		},
		{
			id: 'longTermPlan',
			label: 'Long Term Plan',
			hint: 'Weekly / monthly production plan',
			onClick: openLongTermModal,
			show: !isShowMultiple && !isBakingo,
		},
		{
			id: 'initiatePlan',
			label: 'Initiate Production Plan',
			hint: 'Start a new daily production plan',
			onClick: openInitiateModal,
			show: !isShowMultiple && !isBakingo,
		},
	];

	const searchDropDownOptions = useMemo(() => {
		return [
			{
				label: 'Plan Name',
				value: 'planName',
				placeholder: 'Search by Plan Name...',
			},
			{
				label: 'Plan ID',
				value: 'planId',
				placeholder: 'Search by Plan ID...',
			},
		];
	}, []);

	return (
		<>
			<div className='flex flex-col gap-2 p-4'>
				<div className='flex justify-between'>
					<p className='text-[20px] font-semibold' >Production Plans</p>
					{level !== 1 && (
						<div className='flex flex-wrap items-center justify-end gap-2'>
							{createButtons
								.filter((btn) => btn.show)
								.map((btn) => (
									<Button
										key={btn.id}
										onClick={btn.onClick}
										title={btn.hint}
										className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center gap-1 text-black text-[12px] px-2.5 py-1 whitespace-nowrap'
									>
										<Plus className='size-3.5' />
										{btn.label}
									</Button>
								))}
						</div>
					)}
				</div>
				<div className='flex items-center gap-2 mt-2'>
					<GlobalSearch
						dropDownOptions={searchDropDownOptions}
						searchDropDown={true}
						setSelectedValue={handleSearch}
						placeholderText='Search...'
					/>
					<Button
						onClick={() => toggleFiltersDrawer(true)}
						className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
					>
						<span className='text-nowrap'>Filter & Export</span>
						<Filter className='size-4' />
					</Button>
				</div>
			</div>
		</>
	);
}

const mapStateToProps = (state) => {
	return {};
};

const mapDispatchToProps = {
	toggleFiltersDrawer: drawerActions.toggleFiltersDrawer,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductPlanHeader);
